// Environment configuration for the frontend
export interface EnvironmentConfig {
  restaurantBackendHost: string;
  environment: 'fake' | 'local' | 'dev' | 'prod';
  useDummyData: boolean;
  cognito: {
    userPoolId: string;
    clientId: string;
    region: string;
    clientSecret?: string;
  };
}

// Get environment from build-time variables or default to production
const getEnvironment = (): 'fake' | 'local' | 'dev' | 'prod' => {
  // Check for build-time environment variable first (highest priority)
  console.log('Environment - Build-time environment variable:', process.env.REACT_APP_ENVIRONMENT);
  if (process.env.REACT_APP_ENVIRONMENT) {
    return process.env.REACT_APP_ENVIRONMENT as 'fake' | 'local' | 'dev' | 'prod';
  }
  
  // Check for localhost in window.location to detect fake environment (only if no env var set)
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'fake';
  }
  
  // Check for dev environment hostname
  if (window.location.hostname === 'dev.bespokecast.ai' || window.location.hostname.includes('dev.bespokecast.ai')) {
    return 'dev';
  }
  
  // Default to production
  return 'prod';
};

const environment = getEnvironment();
console.log('Environment - Environment:', environment);

const configs: Record<'fake' | 'local' | 'dev' | 'prod', EnvironmentConfig> = {
  fake: {
    restaurantBackendHost: 'localhost:8000',
    environment: 'fake',
    useDummyData: false,
    cognito: {
      userPoolId: 'us-west-1_yjiLHZSg4',
      clientId: '4g0mq10biks1ssh202cobos1vo',
      region: 'us-west-1'
    }
  },
  dev: {
    restaurantBackendHost: 'api-dev.bespokecast.ai', // Use AWS dev backend for testing
    environment: 'dev',
    useDummyData: false,
    cognito: {
      userPoolId: 'us-west-1_yjiLHZSg4',
      clientId: '4g0mq10biks1ssh202cobos1vo',
      region: 'us-west-1'
    }
  },
  prod: {
    restaurantBackendHost: 'api.bespokecast.ai',
    environment: 'prod',
    useDummyData: false,
    cognito: {
      userPoolId: 'us-west-1_ZGMraZx21',
      clientId: '68oag32mhloisdn8sf3ie6k5a2',
      region: 'us-west-1',
      clientSecret: '1o43or090r3275ablgjf5k8l6bj01lja59gs5vrr080v2uia8f0k'
    }
  },
  local: {
    restaurantBackendHost: 'localhost:8000',
    environment: 'local',
    useDummyData: false,
    cognito: {
      userPoolId: 'us-west-1_ZGMraZx21',
      clientId: '68oag32mhloisdn8sf3ie6k5a2',
      region: 'us-west-1',
      clientSecret: '1o43or090r3275ablgjf5k8l6bj01lja59gs5vrr080v2uia8f0k'
    }
  }
};

export const config = configs[environment];
